export const DEFAULT_FEE_PLAN = 4.4;

export const EMIRATES_FEE_PLAN = 3.14;
export const UK_FEE_PLAN = 4.4;
export const GERMANY_FEE_PLAN = 4.4;
export const DENMARK_FEE_PLAN = 4.4;
export const US_FEE_PLAN = 4.4;
